<template>
  <div class="noticestyle">
    <!-- 公告 -->
    <el-form
      label-width="90px"
      :model="datas"
      :rules="rules"
      size="small"
      class="lef"
      style="margin-top: 20px"
    >
      <el-form-item label="模块名称：">
        <div class="weiz">
          <div class="ml35">
            <el-input disabled v-model="datas.moduleName"> </el-input>
          </div>
        </div>
      </el-form-item>
      <!-- :hide-required-asterisk="true" -->
      <el-form-item label="文本标题：" prop="noticeText">
        <div class="weiz">
          <div class="ml35">
            <el-input placeholder="请输入公告信息" v-model="datas.noticeText">
            </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        label="字体："
        prop="fontWeight"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.fontFamily" placeholder="请选择字体">
              <el-option
                v-for="item in fontFamilyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 标题大小 -->
      <el-form-item
        label="字号："
        prop="fontSize"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.fontSize" placeholder="请选择字号">
              <el-option
                v-for="item in wordSizeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 文字颜色 -->
      <el-form-item class="lef" label="颜色：">
        <div class="weiz" style="display: flex">
          <!-- 1. 修改文字显示逻辑，新增居右判断 -->
          <el-color-picker
            v-model="datas.textColor"
            show-alpha
            @change="handleCustomColorChange($event, 'textColor')"
          ></el-color-picker>
          <el-input placeholder="请输入文字颜色" v-model="datas.textColor">
          </el-input>
        </div>
      </el-form-item>
      <el-form-item class="lef" label="背景：">
        <div class="weiz">
          <div class="ml35">
            <!-- 跳转链接 / 背景颜色子组件 -->
            <LinkInput :datas="datas" field="backColor" defaultColor="defaultBackColor" type="color" />
          </div>
        </div>
      </el-form-item>
      <el-form-item class="lef" label="跳转：">
        <div class="">
          <div class="ml35">
            <!-- 跳转链接 / 背景颜色子组件 -->
            <CustomSelect :datas="datas" :type="1" />
          </div>
        </div>
      </el-form-item>
      <!-- 卡片样式选择 -->
      <el-form-item class="lef" label="模块样式：">
        <div class="weiz">
          <div class="weiz-container" style="">
            <!-- 模块样式 -->
            <div
              v-for="(item, index) in moduleStyleList"
              :key="index"
              @click="clickChange(item, index)"
              class="preview-item"
              :class="{ active: moduleStyleType == item.moduleStyleType }"
            >
              <RightPanelModuleStyle
                :datas="item"
                :imagePath="item.src"
              ></RightPanelModuleStyle>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "noticestyle",
  props: {
    datas: Object,
  },
  data() {
    return {
      moduleStyleType: 1, //默认选中的模块样式
      // 构造模块样式列表
      moduleStyleList: [
        { ...this.datas, src: this.$imagePath.image24,icon: this.$imagePath.image_icon24, moduleStyleType: 1 },
        {
          ...this.datas,
          src: this.$imagePath.image25,
          icon: this.$imagePath.image_icon25,
          moduleStyleType: 2,
        },
        {
          ...this.datas,
          src: this.$imagePath.image26,
          icon: this.$imagePath.image_icon26,
          moduleStyleType: 3,
        },
        {
          ...this.datas,
          src: this.$imagePath.image27,
          icon: this.$imagePath.image_icon27,
          moduleStyleType: 4,
        },
        {
          ...this.datas,
          src: this.$imagePath.image28,
          icon: this.$imagePath.image_icon28,
          moduleStyleType: 5,
        },
        {
          ...this.datas,
          src: this.$imagePath.image29,
          icon: this.$imagePath.image_icon29,
          moduleStyleType: 6,
        },
      ],
      rules: {
        //校验表单输入
        noticeText: [
          //页面名称
          { required: true, message: "请输入公告", trigger: "blur" },
        ],
      },
      predefineColors: [
        // 颜色选择器预设
        "#ff4500",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#00ced1",
        "#1e90ff",
        "#c71585",
        "#409EFF",
        "#909399",
        "#C0C4CC",
        "rgba(255, 69, 0, 0.68)",
        "rgb(255, 120, 0)",
        "hsv(51, 100, 98)",
        "hsva(120, 40, 94, 0.5)",
        "hsl(181, 100%, 37%)",
        "hsla(209, 100%, 56%, 0.73)",
        "#c7158577",
      ],
    };
  },
  created() {},
  methods: {
    // 处理文字颜色选择器变化
    handleCustomColorChange(color, type) {
      console.log("文字颜色选择事件", color, type);
      this.datas[type] = color;
    },
    //模块样式选择回调
    clickChange(item, index) {
      console.log(
        "通知公告模块样式点击了",
        item,
        index,
        this.datas,
        this.moduleStyleType,
      );
      this.moduleStyleType = item.moduleStyleType;
      this.datas.moduleStyleType = item.moduleStyleType;
      this.datas.image = item.icon;
       
    },
  },
};
</script>

<style scoped lang="scss">
.noticestyle {
  width: 100%;
  left: 0;
  top: 0;
  padding: 0 10px 20px;
  box-sizing: border-box;
  /* 标题 */
  h2 {
    padding: 24px 16px 24px 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #f2f4f6;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
  }

  .lef {
    ::v-deep.el-form-item__label {
      text-align: left;
    }
  }

  /* 颜色选择器 */
  .picke {
    float: right;
  }
}
</style>
